import type { CommonCatalog } from "./en";

/** Shared Arabic catalogue (namespace `common`), formal Modern Standard Arabic. */
const ar: CommonCatalog = {
  app: {
    name: "منصة السياسات الوطنية الذكية",
    fullName: "منصة السياسات الوطنية الذكية لدولة الإمارات",
    owner: "الأمانة العامة لمجلس الوزراء",
    ownerFull: "الأمانة العامة لمجلس الوزراء · دولة الإمارات العربية المتحدة",
    government: "حكومة الإمارات العربية المتحدة",
    consoleName: "وحدة إدارة المنصة",
    portalName: "بوابة الاستشارات العامة",
    description: "منصة السياسات الوطنية الذكية لدولة الإمارات - المنصة الاتحادية لإعداد السياسات العامة ومراجعتها وتقييمها",
    consoleDescription: "منصة السياسات الوطنية الذكية - وحدة إدارة المنصة للجهات والهويات ومسارات العمل والوكلاء وحوكمة الذكاء الاصطناعي",
    portalDescription: "الاستشارات العامة بشأن السياسات الاتحادية لدولة الإمارات العربية المتحدة",
    skipToContent: "الانتقال إلى المحتوى الرئيسي",
    copyright: "© {{year}} الأمانة العامة لمجلس الوزراء، دولة الإمارات العربية المتحدة",
  },
  language: {
    switchTo: "English",
    current: "العربية",
    label: "اللغة",
  },
  nav: {
    main: "القائمة الرئيسية",
    home: "الرئيسية",
    commandCenter: "مركز القيادة",
    nationalCommandCenter: "مركز القيادة الوطني",
    policies: "السياسات",
    policyRegister: "سجل السياسات",
    pipelineBoard: "لوحة المسار",
    newPolicy: "سياسة جديدة",
    studio: "استوديو السياسات",
    startPolicy: "بدء سياسة",
    ideas: "الأفكار",
    opportunities: "فرص السياسات",
    directory: "دليل صانعي السياسات",
    benchmarkWatch: "رصد المقارنات المعيارية",
    requirementPacks: "حزم المتطلبات",
    consultation: "الاستشارات",
    consultationRounds: "جولات الاستشارة",
    interMinisterial: "الطلبات بين الجهات الاتحادية",
    monitoring: "المتابعة",
    indicators: "المؤشرات",
    evaluations: "التقييمات",
    reglab: "تجارب مختبر التشريعات",
    signals: "الإشارات",
    knowledge: "المعرفة",
    legislation: "التشريعات والسياسات",
    dataIndicators: "البيانات والمؤشرات",
    benchmarks: "المقارنات المعيارية",
    academy: "الأكاديمية",
    userGuide: "دليل المستخدم",
    registry: "السجل الوطني",
    settings: "الإعدادات",
    members: "الأعضاء",
    roles: "الأدوار",
    portfolio: "ملف الجهة",
    governance: "الحوكمة",
    templates: "القوالب",
    integrations: "التكاملات",
    nationalPipeline: "مسار السياسات الوطني",
    gsocReviews: "قائمة مراجعات الأمانة العامة",
    earlyAdvice: "الرأي المبكر",
    policyAgenda: "أجندة السياسات",
    delegatedAnalyses: "التحليلات المفوَّضة",
    nationalGuidelines: "الإرشادات الوطنية",
    overlaps: "التداخلات والتعارضات",
    cabinetAgenda: "جدول أعمال مجلس الوزراء",
    reglabOffice: "مكتب مختبر التشريعات",
    nationalSignals: "الإشارات الوطنية",
    performance: "الأداء والتقييم",
    conformanceAnalytics: "تحليلات المطابقة",
    designSystem: "نظام التصميم",
    work: "العمل",
    oversight: "الرقابة",
    resources: "الموارد",
    administration: "الإدارة",
    openConsole: "فتح وحدة إدارة المنصة",
    sectionPolicy: "أعمال السياسات",
    sectionNational: "الرقابة الوطنية",
  },
  actions: {
    signIn: "تسجيل الدخول",
    signOut: "تسجيل الخروج",
    save: "حفظ",
    cancel: "إلغاء",
    close: "إغلاق",
    back: "رجوع",
    next: "التالي",
    continue: "متابعة",
    submit: "إرسال",
    retry: "إعادة المحاولة",
    search: "بحث",
    filter: "تصفية",
    export: "تصدير",
    edit: "تعديل",
    delete: "حذف",
    accept: "قبول",
    reject: "رفض",
    view: "عرض",
    open: "فتح",
    create: "إنشاء",
    run: "تشغيل",
    markAllRead: "تعليم الكل كمقروء",
    viewAll: "عرض الكل",
    goHome: "الانتقال إلى الصفحة الرئيسية",
    reload: "إعادة تحميل الصفحة",
    switchTenant: "تبديل مساحة العمل",
    openAssistant: "المساعد الذكي",
    history: "السجل",
    file: "الملف",
  },
  states: {
    loading: "جارٍ التحميل…",
    saving: "جارٍ الحفظ…",
    empty: "لا توجد بيانات لعرضها بعد",
    comingSoon: "يجري ربط هذه الشاشة بخدمات المنصة.",
    notAvailable: "غير متاح",
    none: "لا يوجد",
    yes: "نعم",
    no: "لا",
    offline: "أنت غير متصل بالشبكة",
  },
  errors: {
    apiUnavailableTitle: "تعذّر الوصول إلى خدمة المنصة",
    apiUnavailableBody: "لم نتمكن من الوصول إلى خدمة منصة السياسات الوطنية الذكية. يُرجى التحقق من الاتصال أو إعادة المحاولة بعد قليل، وإذا استمرت المشكلة فيُرجى التواصل مع فريق دعم المنصة.",
    genericTitle: "حدث خطأ",
    genericBody: "تعذّر إكمال الطلب. يُرجى إعادة المحاولة، وإذا تكرر الخطأ فقد أُبلغ فريق المنصة بذلك.",
    forbiddenTitle: "لا تملك صلاحية الوصول إلى هذه الصفحة",
    forbiddenBody: "لا يتضمن دورك في مساحة العمل هذه صلاحية الوصول إلى هذا القسم. يُرجى التواصل مع مسؤول مساحة العمل إذا احتجت إلى الوصول.",
    notFoundTitle: "الصفحة غير موجودة",
    notFoundBody: "ربما يكون الرابط غير صحيح، أو نُقلت الصفحة.",
    boundaryTitle: "توقفت هذه الشاشة عن العمل",
    boundaryBody: "حدث خطأ غير متوقع أثناء عرض هذه الشاشة، ولا يتأثر العمل المحفوظ بذلك.",
    validation: "بعض الحقول تحتاج إلى مراجعة.",
    conflict: "عدّل مستخدم آخر هذا العنصر. يُرجى إعادة التحميل للاطلاع على أحدث نسخة.",
    stepUpRequired: "يتطلب هذا الإجراء تأكيد هويتك مرة أخرى.",
    correlation: "المرجع: {{id}}",
  },
  auth: {
    title: "تسجيل الدخول إلى منصة السياسات الوطنية الذكية",
    subtitle: "المنصة الاتحادية لإعداد السياسات العامة ومراجعتها وتقييمها.",
    sso: "تسجيل الدخول عبر نظام الدخول الموحد لحكومة دولة الإمارات",
    ssoHint: "استخدم حسابك الحكومي. يقتصر الوصول على موظفي الجهات الاتحادية المصرَّح لهم.",
    uaePass: "تسجيل الدخول باستخدام الهوية الرقمية (UAE PASS)",
    uaePassHint: "استخدم حسابك الموثّق في الهوية الرقمية، ثم وافق على تسجيل الدخول في تطبيق الهوية الرقمية.",
    directory: "تسجيل الدخول عبر {{name}}",
    gateTitle: "تسجيل الدخول إلى {{name}}",
    gateSubtitle: "هذه بوابة الدخول الخاصة بالوزارة، ولا تفتح إلا مساحة عمل هذه الوزارة.",
    gateUnknown: "رابط الدخول هذا لا يخص أي مساحة عمل. استخدم صفحة الدخول الرئيسية أدناه.",
    leaveGate: "لست من موظفي {{name}}؟ استخدم صفحة الدخول الرئيسية",
    thisWorkspace: "مساحة العمل هذه",
    notMember: "حسابك ليس عضواً في {{name}}. اطلب دعوة من مسؤول مساحة عمل الوزارة، أو استخدم صفحة الدخول الرئيسية.",
    uaePassLevel: "حسابك في الهوية الرقمية غير موثّق بالمستوى المطلوب لموظفي الحكومة. يُرجى ترقيته إلى حساب موثّق في تطبيق الهوية الرقمية ثم المحاولة مرة أخرى.",
    devTitle: "شخصيات بيئة التطوير",
    devBadge: "تطوير",
    devHint: "متاحة في بيئات التطوير فقط. اختر شخصية لتسجيل الدخول بصفتها.",
    signInAs: "تسجيل الدخول بصفة {{name}}",
    signingIn: "جارٍ تسجيل الدخول…",
    noMethods: "لم تُهيّأ أي وسيلة لتسجيل الدخول في هذه البيئة. يُرجى التواصل مع فريق المنصة.",
    sessionExpiredTitle: "انتهت الجلسة",
    sessionExpiredBody: "حفاظاً على أمان حسابك، سُجِّل خروجك. يُرجى تسجيل الدخول مجدداً للمتابعة، وعملك المحفوظ باقٍ كما هو.",
    signInAgain: "تسجيل الدخول مجدداً",
    stepUp: "تأكيد الهوية",
    stepUpRecent: "أُكِّدت الهوية {{time}}",
    stepUpNone: "لم تُؤكَّد الهوية في هذه الجلسة",
    stepUpStart: "تأكيد الهوية",
    stepUpCode: "رمز التحقق",
    stepUpVerify: "التحقق",
    profile: "ملفي الشخصي",
    roles: "الأدوار",
    workspace: "مساحة العمل",
    workspaces: "مساحات العمل الخاصة بك",
    currentWorkspace: "مساحة العمل الحالية",
    defaultWorkspace: "الافتراضية",
    switched: "أنت تعمل الآن في {{name}}.",
    signedOut: "سُجِّل خروجك.",
    notEnrolled: "حسابك الحكومي غير مسجّل في منصة السياسات الوطنية الذكية. اطلب الوصول من مسؤول مساحة العمل.",
    ssoFailed: "لم يكتمل الدخول الموحد. يُرجى المحاولة مرة أخرى، وإذا تكرر الخطأ فتواصل مع فريق المنصة.",
    personasUnavailable: "تعذّر تحميل شخصيات بيئة التطوير.",
    heroEyebrow: "المنصة الاتحادية للسياسات",
    heroTitle: "سياسات أفضل وأسرع، بذكاء اصطناعي يوضّح مصادره",
    features: {
      ai: "يُعدّ الذكاء الاصطناعي مسودة كل مرحلة ويستشهد بالأدلة التي يستند إليها",
      guidebook: "يتحقق من مطابقة كل سياسة لدليل إعداد السياسات العامة قبل المراجعة",
      bilingual: "يعمل بالعربية والإنجليزية على حد سواء في جميع المراحل",
    },
  },
  notifications: {
    title: "الإشعارات",
    unread_one: "إشعار واحد غير مقروء",
    unread_other: "الإشعارات غير المقروءة: {{count}}",
    empty: "لا توجد إشعارات جديدة.",
    emptyHint: "تظهر هنا المهام والقرارات ومقترحات الذكاء الاصطناعي الموجهة إليك.",
    markRead: "تعليم كمقروء",
    open: "فتح الإشعارات",
  },
  views: {
    label: "طرق العرض المحفوظة",
    save: "حفظ طريقة العرض",
    saveTitle: "حفظ طريقة العرض هذه",
    saveHint: "تحتفظ بعوامل التصفية والترتيب الحالية لتعود إليها بنقرة واحدة.",
    name: "الاسم",
    namePlaceholder: "مثلاً: سياساتي المتأخرة",
    saved: "حُفظت طريقة العرض «{{name}}»",
    remove: "إزالة طريقة العرض «{{name}}»",
    removed: "أُزيلت طريقة العرض",
    showAs: "العرض على شكل",
    table: "جدول",
    board: "لوحة",
  },
  autosave: {
    saved: "حُفظت المسودة {{time}}",
    hint: "تُحفظ إجاباتك على هذا الجهاز حتى تنتهي.",
  },
  settingsNav: {
    label: "أقسام الإعدادات",
  },
  palette: {
    label: "لوحة الأوامر",
    placeholder: "البحث في الصفحات والإجراءات…",
    empty: "لا توجد صفحة أو إجراء مطابق.",
    pages: "الصفحات",
    actions: "الإجراءات",
    hint: "اضغط {{key}} لفتح لوحة الأوامر",
    open: "بحث",
    openLong: "البحث في الصفحات والإجراءات",
    askAi: "سؤال المساعد الذكي",
  },
  assistant: {
    ask: "سؤال المساعد الذكي",
    title: "المساعد الذكي",
  },
  dictation: {
    start: "إملاء صوتي",
    stop: "إيقاف وتحويل إلى نص",
    recording: "جارٍ التسجيل {{time}}",
    transcribing: "جارٍ التحويل إلى نص…",
    micBlocked: "لم يسمح المتصفح باستخدام الميكروفون. اسمح به لهذا الموقع ثم أعد المحاولة.",
    empty: "لم يُلتقط أي كلام في التسجيل.",
    note: "يُحوَّل صوتك إلى نص على حوسبة حكومية ولا يُحتفظ به. راجع النص قبل الحفظ.",
  },
  tenant: {
    ministry: "وزارة",
    oversight: "الأمانة العامة لمجلس الوزراء",
    platform: "المنصة",
  },
  time: {
    justNow: "الآن",
  },
  enums: {},
};

export default ar;
